<template>
	<div class="cart-item">
		<router-link :to="'/product/' + item.id">
			<img :src="item.img" class="img" :alt="item.name">
		</router-link>
		<div class="cart-content">
			<p class="info">
				<span class="name">{{ item.name }}</span>
			</p>
			<p class="qty">{{ item.qty }} x <span>$</span>{{ item.price }}</p>
			<p class="nav">
				<span class="total">Total: <span>$</span>{{ (item.qty * item.price).toFixed(2) }}</span>
				<span class="ctrl" v-if="!hideNav">
					<button class="btn" @click="reduceOne()">-</button>
					<span>{{ item.qty }}</span>
					<button class="btn" @click="addOne()">+</button>
				</span>
			</p>
		</div>
	</div>
</template>

<script>
	export default{
		name: 'CartItem',
		props: ['item', 'hideNav'],
		methods: {
			addOne(){
				this.item.qty++
			},
			reduceOne(){
				let q = this.item.qty
				if(q < 2){
					this.$emit('removeFromCart')
				}else{
					this.item.qty--
				}
			}
		}
	}
</script>

<style>
.cart-item{
	padding: 10px;
	height: 75px;
	border-radius: 5px;
	box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
	display: flex;
	margin-bottom: 15px;
}
.cart-item .img{
	height: 100%;
	width: 60px;
	border-radius: 4px;
	margin-right: 10px;
}
.cart-content{
	flex-grow: 1;
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}
.cart-content .info{
	display: flex;
	justify-content: space-between;
	font-size: 1.1em;
}
.cart-content .info .name{
	font-weight: 900;
	color: #373737;
}
.cart-content .qty span{
	color: var(--primary-color);
	font-weight: 400;
}
.cart-content .qty{
	font-size: 1em;
}
.cart-content .nav{
	font-size: 0.8em;
	display: flex;
	align-items: center;
	justify-content: space-between;
}
.cart-content .nav .total span{
	color: var(--primary-color);
}
.cart-content .nav .ctrl .btn{
	display: inline-block;
	height: 30px;
	width: 30px;
	border: 3px solid var(--primary-light);
	padding: 0;
	border-radius: 50%;
	font-size: 15px;
	box-shadow: none;
}
.cart-content .nav .ctrl span{
	margin: 0 7px;
}
</style>